export default __webpack_public_path__ + "static/media/247Support.ec62db8b.svg";